module.exports = __webpack_public_path__ + "img/4.5fced9b6.jpg";